<template>
<div>
  <div class="popup-content ">
    <div class="image-cover sides">
      <img src="https://static-nz.s3-ap-southeast-2.amazonaws.com/nz/images/menu/crust_image/group-13%402x.png" alt="">
    </div>
    <div class="popup-body p-20">

      <div class="popup-title bold uppercase">{{$t('stuff_your_crust')}}</div>
      <div class="m-10">{{$t('take_pizza_upsell')}}</div>
      <div class="line"></div>
      <div v-for="(item,index) in items" :key="'chil'+index">
        <div class="variant-addon-item option display-flex t15 p10 bg-grey-lightestest md:bg-transparent cursor-pointer" @click="choosedItem(item)">
          <div class="flex1 text-black fw400">
            <span class="radio variant-addon-item-size text-black" v-bind:class="{'checked' : picked.name == item.name}"></span>
            <i class="pull-left"></i> <span>{{item.name}}</span>
          </div>
          <div class="fw600 text-right pl10 pr10 pull-right">+{{ $const.CURRENCY }} {{formatNum(item.showPrice)}}</div>
        </div>
      </div>
      <div class="line"></div>
      <div class="popup-button-group">
        <button class="popup-btn-success btn-success bold" @click="submit">{{$t('add_to_pizza')}}</button>
        <button class="popup-btn-cancel bold" @click="cancel">{{$t('no_thanks')}}</button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  export default{
    props : ['items','previousItem','isDefault', 'trackingItem'],
    data() {
      return {
        picked : {}
      }
    },
    destroyed () {
      this.$root.$emit('onTrackingCategory')
    }
    ,
    mounted(){
      this.eventTrackingProductDetail(this, this.trackingItem, this.$const.CARD_ITEM_TYPE.SINGLE)
      if(!this.lodash.isEmpty(this.isDefault)){
        this.choosedItem(this.isDefault, false)
        this.$forceUpdate(this.picked)
      }
    },
    methods : {
      choosedItem(item, disableEvent = true){
        this.picked = item
        let data = this.lodash.cloneDeep(item)
        let product = data.item
        let choosedFirst = this.lodash.cloneDeep(data.first)
        let choosedSecond = this.lodash.cloneDeep(data.second)
        product.first_layers = []
        product.first_layers.push(choosedFirst)
        if (choosedFirst != null && !this.empty(choosedFirst)) {
          product.first_layers[0].second_layers = [choosedSecond]
        }
        product.price = data.price
        if (disableEvent) {
          let variantUUid = ''
          if (!this.empty(choosedFirst) && choosedFirst.uuid != '') {
            variantUUid = choosedFirst.uuid
          }
          if (!this.empty(choosedSecond) && choosedSecond.uuid != '') {
            variantUUid += '-' + choosedSecond.uuid
          }
          this.evenTrackingProductClick(this, {uuid: product.uuid, variant_uuid: variantUUid}, 'product-selection-from-variant-list')
          // this.eventTrackingProductView(product.uuid)
          // this.eventTrackingProductDetail(this, product, this.$const.CARD_ITEM_TYPE.SINGLE, 'product-details')
        }
      },
      trackAddCart(menu) {
        let pro = {
          item: menu,
          id: menu.products.length> 0 ? menu.products[0].product_id : '',
          name: menu.name,
          price: menu.price,
          first: {},
          second: {}
        }
        if (menu.products.length > 0 && menu.products[0].first_id != '') {
          pro.first = {
            uuid: menu.products[0].first_id
          }
        }
        if (menu.products.length > 0 && menu.products[0].second_id != '') {
          pro.second = {
            uuid: menu.products[0].second_id
          }
        }
        this.eventTrackingAddToCart(this, pro, 'main', this.$const.CARD_ITEM_TYPE.SINGLE)
      },
      submit(){
        this.trackAddCart(this.picked)
        this.$cart.insert(this,this.picked)
        this.$emit('close')
      },
      cancel(){
        this.trackAddCart(this.previousItem)
        this.$cart.insert(this, this.previousItem)
        this.$emit('close')
      }
    }
  }
</script>
<style scoped>
  .popup-content {
    width: 90%;
    max-width: 800px;
    height: calc(100% - 60px);
    left: 0;
    right: 0;
    border-radius: 10px;
    top: 50%;
    background: #fff;
    background-color: #fff;
    margin: 0 auto;
    margin-top: 5vh;
  }
  .popup-title {
    font-family: SharpSans;
    font-size: 23px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #313131;
  }
  .popup-btn-success {
    width: 100%;
    height: 44px;
    border-radius: 5px;
  }
  .popup-btn-cancel {
    margin-top:16px;
    width: 100%;
    height: 44px;
    border-radius: 5px;
    border: solid 1px #dfdfe3;
    background-color: #e9ebee;
  }
  .popup-button-group {
    padding-top : 16px;
  }
  .line {
    border: 0.5px solid #e9ebee;
  }
  .image-cover {
    width: 40%;
    bottom: 0px;
    background: #f3f3f6;
    align-items: center;
    overflow: hidden;
    display: flex;
    object-fit: contain !important;
    height: auto !important;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }
  .image-cover img {
    width: 100%;
  }
  .popup-content {
    display: flex;
  }

  @media (max-width: 800px){

    .image-cover img{
      width: 100%;
      margin-left: 0;
      height: auto;
      -o-object-fit: contain;
      object-fit: contain;
      -webkit-transform: scale(1);
      transform: scale(1);
       /*max-height: 240px;*/
    }
    .popup-content {
      display: block;
    }
    .image-cover {
      display: none;
      width: calc(100% + 20px);
      margin: 0px -10px;
      max-height: 300px;
    }
}
@media (max-width: 500px){
  .image-cover img {
    width: 100%;
  }
  .popup-content {
    display: block;
  }
  .image-cover {
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/popup/ModalPizzaUpSell.vue